export const CLICKWRAP_ACCESS_ID = "5d800911-f26c-4e3a-884d-85117a81799b";

export const ONE_ID_COMPLETION_TIMESTAMP_KEY = "one_id_completion_timestamp";
